import { linkToAssignmentsOverviewPage } from "../../links";

export function linkToShareAssignment(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToAssignmentsOverviewPage(classId)}/share/${assignmentId}`;
}
